import React from "react";
import PropTypes from "prop-types";

const AddressBlock = props => {
  const { address, showAddressDefault } = props;
  if (Object.keys(address).length > 0) {
    return (
      <address className="nw-addressblock-wrapper">
        <span>
          {address.name}{" "}
          {showAddressDefault && address.default && (
            <span className="nw-addressblock-default">(Default)</span>
          )}
        </span>
        <span>{`${address.firstLine}, ${address.secondLine || ""}`}</span>
        <span>{address.landmark || ""}</span>
        <span>
          {`${address.city}, ${address.state}, ${address.country} - ${
            address.pincode
          }`}
        </span>
      </address>
    );
  }
  return null;
};

AddressBlock.defaultProps = {
  address: {},
  showAddressDefault: false,
};

AddressBlock.propTypes = {
  address: PropTypes.shape({}),
  showAddressDefault: PropTypes.bool,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: AddressBlock,
  component: AddressBlock,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/AddressBlock/index.js